import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { saveToken } from '../../auth';
import API_BASE_URL from '../../config';

export default function Register({ onAuth }) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [adminCode, setAdminCode] = useState('');
  const [err, setErr] = useState('');
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, password, adminCode })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'Registration failed');
      saveToken(data.token);
      onAuth();
      nav('/reports');
    } catch (ex) {
      setErr(ex.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="glass-panel relative p-6 md:p-8 w-full max-w-sm md:max-w-md rounded-2xl shadow-2xl border border-white/10 bg-dark-900/40 dark:bg-dark-900/60 backdrop-blur-xl animate-fade-in-up">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 md:w-32 h-1 bg-primary-500/50 blur-[4px] rounded-full"></div>

        <h2 className="text-2xl md:text-3xl font-display font-bold text-center mb-2 text-main">Create Account</h2>
        <p className="text-center text-muted text-xs md:text-sm mb-6 md:mb-8">Join the community to report road issues</p>

        {err && (
          <div className="mb-6 p-4 rounded-xl bg-red-500/10 border border-red-500/20 text-sm text-red-500 font-medium flex items-center gap-2">
            <svg className="w-5 h-5 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" /></svg>
            {err}
          </div>
        )}

        <form onSubmit={submit} className="space-y-4 md:space-y-5">
          <div className="space-y-1">
            <label className="text-[10px] md:text-xs font-bold text-muted uppercase tracking-wider ml-1">Full Name</label>
            <input
              className="w-full px-4 py-3 rounded-xl bg-dark-800/10 dark:bg-dark-800/50 border border-dark-800/20 dark:border-white/10 text-main placeholder-muted/50 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 transition-all duration-300 text-sm md:text-base"
              placeholder="e.g. John Doe"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] md:text-xs font-bold text-muted uppercase tracking-wider ml-1">Email</label>
            <input
              className="w-full px-4 py-3 rounded-xl bg-dark-800/10 dark:bg-dark-800/50 border border-dark-800/20 dark:border-white/10 text-main placeholder-muted/50 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 transition-all duration-300 text-sm md:text-base"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] md:text-xs font-bold text-muted uppercase tracking-wider ml-1">Password</label>
            <input
              type="password"
              className="w-full px-4 py-3 rounded-xl bg-dark-800/10 dark:bg-dark-800/50 border border-dark-800/20 dark:border-white/10 text-main placeholder-muted/50 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 transition-all duration-300 text-sm md:text-base"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="space-y-1">
            <label className="text-[10px] md:text-xs font-bold text-muted uppercase tracking-wider ml-1">Admin Code <span className="text-muted/50 normal-case font-normal">(Optional)</span></label>
            <input
              className="w-full px-4 py-3 rounded-xl bg-dark-800/10 dark:bg-dark-800/50 border border-dark-800/20 dark:border-white/10 text-main placeholder-muted/50 focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 transition-all duration-300 text-sm md:text-base"
              placeholder="Enter code only if applicable"
              value={adminCode}
              onChange={(e) => setAdminCode(e.target.value)}
            />
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-primary-600 to-primary-500 hover:from-primary-500 hover:to-primary-400 text-white py-3 md:py-3.5 rounded-xl font-bold text-base md:text-lg shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40 hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] transition-all duration-200 mt-2"
          >
            Create Account
          </button>
        </form>

        <p className="mt-6 md:mt-8 text-xs md:text-sm text-center text-muted">
          Already have an account?{' '}
          <Link to="/login" className="text-primary-500 font-bold hover:text-primary-400 hover:underline transition-colors">
            Login
          </Link>
        </p>
      </div>
    </div>
  );
}
